const ja = {
  app: {
    title: "MeW ディスペンサーマップ",
    signInPrompt: "Google アカウントでサインインし、シート・写真フォルダを準備します。",
    signInGoogle: "Google でサインイン",
    signOut: "サインアウト",
    setupBanner: "あと少しです。フォームを開いて回答用スプレッドシートと連携してください：フォームの「回答」→「スプレッドシートにリンク」→ 作成済みのスプレッドシートを選択。",
    openForm: "フォームを開く",
    setupError: "起動時のセットアップに失敗しました: {{msg}}",
    dismiss: "閉じる",
    staleMewTitle: "以前のプロジェクトが見つかりません",
    staleMewBody: "ブラウザに保存されている MeW Maps プロジェクトが Google Drive に存在しません。新しいプロジェクトを作成します。",
    staleMewImplications: "保存データへの影響:",
    staleMewImp1: "削除（推奨）— 古いフォルダ・ファイルの参照を削除し、新プロジェクトを完全な白紙の状態で開始します。",
    staleMewImp2: "保持 — 古い Drive の参照がブラウザに残り、写真・アイコン・アセットが見つからないか誤ったファイルを参照する場合があります。",
    staleMewImp3: "どちらの場合も、新プロジェクトの設定はこの後のセットアップウィザードで行います。",
    staleMewClear: "古いデータを削除",
    staleMewKeep: "古い参照を保持",
  },
  nav: {
    sheet: "シート",
    field: "現地入力",
    tasks: "タスク",
    kml: "KML",
    map: "マップ",
    email: "メール",
    members: "メンバー",
    formSettings: "フォーム",
    import: "一括取込",
    fieldworker: "現地担当",
    advancedOn: "詳細モードを有効にしました。一括取込が表示されます。",
    advancedOff: "詳細モードを無効にしました。",
  },
  account: {
    menu: "アカウント",
    manager: "管理者",
  },
  onboard: {
    chooseTitle: "はじめる",
    chooseSubtitle: "自分の MeW Maps プロジェクトを作成するか、共有されたプロジェクトに参加します。",
    createTitle: "新しいプロジェクトを作成",
    createDesc: "自分の Google Drive にシートと写真フォルダを新規作成します。",
    joinTitle: "共有プロジェクトに参加",
    joinDesc: "管理者から共有されたプロジェクトに参加します。データのスプレッドシートと写真フォルダを選択して現地入力します。",
    joining: "共有プロジェクトに接続中…",
    joined: "「{{name}}」に参加しました。現地入力を開始できます。",
    ownedTitle: "このフォルダはご自身のものです",
    ownedBody: "「{{name}}」はご自身が所有しているため、参加する必要はありません。「新しいプロジェクトを作成」を使用してください。",
    joinError: "参加できませんでした: {{msg}}",
    back: "戻る",
  },
  common: {
    processing: "処理中…",
    error: "エラー",
    pickerCookieHint: {
      firefox: "Firefox をお使いですか？ ファイル選択画面が表示されない、または「The API developer key is invalid」と表示される場合は、Firefox のトラッキング防止機能が Google ログインをブロックしています。アドレスバーの盾アイコンをクリックし、このサイトの強化型トラッキング防止を無効にしてから、もう一度お試しください。",
      safari: "Safari をお使いですか？ ファイル選択画面が表示されない、または「The API developer key is invalid」と表示される場合は、Safari のサイト越えトラッキング防止が Google ログインをブロックしています。Safari →「設定」→「プライバシー」で「サイト越えトラッキングを防ぐ」のチェックを外し、このページを再読み込みしてからもう一度お試しください。",
      brave: "Brave をお使いですか？ ファイル選択画面が表示されない、または「The API developer key is invalid」と表示される場合は、Brave Shields が Google ログインをブロックしています。アドレスバーの Brave Shields（ライオン）アイコンをクリックし、このサイトの Shields を下げてから、もう一度お試しください。",
      generic: "ファイル選択画面が正常に開く場合は、このメッセージは無視してかまいません。表示されない、または「The API developer key is invalid」と表示される場合は、お使いのブラウザが Google のサードパーティ Cookie をブロックしている可能性があります。このサイトと google.com の Cookie を許可（またはトラッキング防止を無効に）してから、ページを再読み込みしてもう一度お試しください。",
    },
    save: "保存",
    saving: "保存中…",
    cancel: "キャンセル",
    notSpecified: "(未指定)",
    open: "開く",
    rows: "行",
    lastSync: "最終同期",
    settings: "設定",
    language: "言語",
  },
  sheet: {
    commands: "コマンド",
    addRow: "行を追加",
    importExcel: "Excel をインポート",
    exportKml: "KML をエクスポート",
    generateQr: "QR コードを生成 ({{count}})",
    qrSettings: "QR コード設定",
    qrMessage: "QR の説明文（任意）",
    qrFormUrl: "フォーム URL（リンク済み）",
    qrFormUrlMissing: "フォーム未連携です。フォーム画面で新規作成するか、既存 URL をインポートしてください。",
    qrFormUrlRequired: "QR コードを生成する前に、フォーム画面で作成またはインポートしてください。",
    qrManageForm: "フォーム項目を管理",
    qrColumns: "列数",
    qrWidth: "QR サイズ (px)",
    qrShowLabel: "表記名を表示",
    qrShowInstallLocation: "設置場所を表示",
    qrRows: "1ページの行数 (0 = 自動)",
    qrPageSize: "用紙サイズ",
    qrOrientation: "向き",
    qrOrientation_portrait: "縦",
    qrOrientation_landscape: "横",
    qrMargin: "余白 (mm)",
    qrGap: "間隔 (mm)",
    noRowsSelected: "行を 1 つ以上選択してください",
    qrGenerating: "QR コードを生成中…",
    qrGenerated: "{{count}} 行の QR コードを生成しました",
    qrError: "QR 生成エラー: {{msg}}",
    reload: "シートを再読込",
    openGoogleSheet: "Google Sheet を開く",
    addedRow: "新しい行を追加しました",
    addError: "追加エラー: {{msg}}",
    renamePhotosManually: "IDを変更しました {{from}} → {{to}}。写真のリンクは保持されますが、ファイル名は古いIDのままです。整理したい場合は Drive で名前を変更してください。",
    importingExcel: "Excel を読み込み中…",
    importNoRows: "Excel に行がありませんでした",
    importedRows: "{{count}} 行をインポートしました",
    importError: "インポートエラー: {{msg}}",
    saveError: "保存エラー: {{msg}}",
    reportUrlCopied: "報告フォーム URL をコピーしました: {{id}}",
    copyFailed: "クリップボードへのコピーに失敗",
    enterIdFirst: "先に ID を入力してください",
    uploadingPhotos: "{{id}} の写真をアップロード中…",
    uploadedPhotos: "{{count}} 枚の写真をアップロードしました",
    photoUploadError: "写真アップロードエラー: {{msg}}",
    confirmDelete: "{{id}} の行と写真を削除しますか？この操作は取り消せません。",
    deletingRow: "{{id}} を削除中…",
    deletedRow: "{{id}} を削除しました",
    deleteError: "削除エラー: {{msg}}",
    deleteSelected: "選択した行を削除 ({{count}})",
    confirmDeleteSelected: "選択した {{count}} 行と写真を削除しますか？この操作は取り消せません。",
    deletingSelected: "{{count}} 行を削除中…",
    deletedSelected: "{{count}} 行を削除しました",
  },
  formSettings: {
    title: "フォーム設定",
    intro: "すべての QR コードで使用する Google フォームの項目を定義します。ラベル「ID」の行が事前入力フィールドとなり、ディスペンサーの ID が自動で挿入されます。",
    linkedFormHeader: "連携済み Google フォーム",
    linkedFormSafe: "ID 項目が残っている限り、同期しても事前入力 URL は維持されます。アプリがフォームファイルを削除することはありません。",
    notLinkedYet: "まだフォームが連携されていません。下のスキーマから新規作成するには「同期」、既存運用の場合は「既存 URL をインポート」してください。",
    linkPruned: "連携先のフォームが存在しなくなったため、リンクを解除しました。「スキーマから作成」で新規作成してください。",
    linkKept: "リンクを保持しました。後でアクセス権が付与される可能性があります。",
    scanFolder: "forms/ フォルダをスキャン",
    confirmScanFolder: "forms/ フォルダをスキャンして、最初に見つかったフォーム（Template を除く）を連携しますか？",
    scanLinked: "forms/ フォルダから「{{name}}」を連携しました。",
    scanError: "スキャンエラー: {{msg}}",
    reuseExistingForm: "既存フォームを再利用（ID 指定）…",
    reuseReplace: "既存フォームに差し替え（ID 指定）…",
    pickReuseTitle: "再利用するフォームを選択",
    confirmReuseForm: "「{{name}}」を ID で連携し、そのまま再利用しますか？MewMaps は QR リンク作成のために読み取りますが、編集は一切行いません（同期・公開・再構築なし）。すでに QR コードがこのフォームを指しているアプリからの移行時に使用します。",
    reuseLinked: "「{{name}}」を再利用します（読み取り専用）。新しい QR コード用に事前入力 URL を保存しました。フォームは変更されません。",
    reuseLinkedNoId: "「{{name}}」を再利用します（読み取り専用）。「ID」質問がないため、通常のフォーム URL を保存しました。既存の QR コードはそのまま使用できます。",
    reuseError: "ID 再利用エラー: {{msg}}",
    reusedReadOnly: "ID で再利用中 — MewMaps はこのフォームを読み取りますが編集しません。",
    confirmPruneInaccessible: "連携先の Google フォームに現在アクセスできません。リンクを解除しますか？キャンセルで保持できます（後でアクセス権が付与される場合があります）。",
    sync: "スキーマをフォームへ同期",
    syncing: "Google フォームへ同期中…",
    syncedExisting: "連携済みフォームを更新しました。事前入力 URL は維持されました。",
    syncError: "フォーム同期エラー: {{msg}}",
    confirmSyncExisting: "連携済みフォームの ID 以外の項目を一旦削除し、保存済みスキーマで再構築します。事前入力 URL は維持されます。続行しますか？",
    createFromSchema: "スキーマから作成",
    creating: "Google フォームを作成中…",
    createdFromSchema: "保存済みスキーマから Google フォームを作成しました。事前入力 URL: {{url}}",
    createError: "フォーム作成エラー: {{msg}}",
    confirmCreateFromSchema: "保存済みスキーマから Google フォームを新規作成しますか？",
    importExistingUrl: "既存 URL をインポート",
    replaceUrl: "リンク URL を差し替え…",
    detach: "フォームを切り離す",
    confirmDetach: "リンク済みのフォームを切り離しますか？現在の URL は消去されますが、バックアップに保存されるため復元可能です。Google フォーム自体は削除されません。",
    detached: "フォームを切り離しました。URL は消去され、バックアップに保存されました。",
    detachError: "切り離しエラー: {{msg}}",
    createResponsesSheet: "回答シートを作成",
    confirmCreateResponsesSheet: "このフォーム用の回答スプレッドシートを作成しますか？作成後、ご自身でフォームと連携してください：フォームの「回答」→「スプレッドシートにリンク」→ このスプレッドシートを選択。",
    creatingResponsesSheet: "回答スプレッドシートを作成中…",
    responsesSheetCreated: "回答スプレッドシートを作成しました。フォームと連携してください：「回答」→「スプレッドシートにリンク」→ これを選択。",
    responsesSheetAlreadyLinked: "このフォームにはすでに回答スプレッドシートが連携されています。",
    responsesSheetAdopted: "このフォームに既に接続されている回答シートを使用します。作成・変更は行いませんでした。",
    responsesSheetError: "回答シートエラー: {{msg}}",
    useLinkedResponsesSheet: "接続済みの回答シートを使用",
    checkResponsesSheet: "回答シートを確認",
    noSheetAttached: "この再利用フォームには回答シートが接続されていません。メール通知には回答シートが必要です。",
    createResponsesSheetOptional: "回答シートを作成（任意）",
    confirmCreateDetachedSheet: "このフォームには回答シートが接続されていません。新しい単独のシートを作成しますか？作成後、Google フォームでご自身で接続してください（「回答」→「スプレッドシートにリンク」）。フォーム自体は変更されません。",
    detachedSheetCreated: "回答シートを作成しました。フォームと連携してください：「回答」→「スプレッドシートにリンク」→ これを選択。",
    publishForm: "フォームを公開",
    confirmPublish: "リンク済みのフォームを公開し、回答を受け付ける状態にしますか？",
    publishing: "フォームを公開中…",
    published: "フォームを公開し、回答を受け付ける状態にしました。",
    publishError: "公開エラー: {{msg}}",
    openResponsesSheet: "回答シートを開く",
    emailBackend: "メールバックエンド設定",
    emailBackendExplain: "回答シートからメール通知を有効にするためのコードと手順を表示します（MewMail ライブラリを追加して setup を実行）。",
    emailBackendDialogTitle: "メール通知を有効にする",
    emailBackendDone: "メールバックエンドは設定済みです。",
    emailBackendNeedForm: "先にフォームをリンクし、回答シートを作成してください。",
    restoreBackup: "前回の URL を復元",
    colAction: "操作",
    colExplanation: "内容",
    explain: {
      createFromSchema:
        "テンプレートフォームを複製して項目を消去し、保存済みスキーマから質問を作り直して新しいフォームのリンクを保存します。すでにフォームがリンクされている場合は実行しません。",
      scanFolder:
        "Drive の forms/ フォルダ内で最初に見つかった Google フォーム（テンプレートを除く）をリンクし、その「ID」質問から事前入力 URL を作成します。すでにフォームがリンクされている場合は実行しません。",
      reuseExistingForm:
        "既存の Google フォーム（他アカウントから共有されたものでも可）を選んで ID で再利用します。すでに QR コードがそのフォームを指しているアプリからの移行に最適です。読み取り専用でリンクされ、MewMaps は事前入力 URL の作成のために読み取るだけで、編集・公開・再構築は行いません。",
      importUrl:
        "貼り付けた事前入力 URL（&entry.<番号>= を含む必要があります）をリンク先として設定します。直前のリンクはバックアップされます。フォーム・回答シートは変更しません。",
      sync:
        "リンク済みの Google フォームの ID 以外の項目をすべて削除し、保存済みスキーマから作り直します。「ID」質問は保持されるため、事前入力 URL は維持されます。",
      openGoogleForm: "リンク済みの Google フォームの編集画面を新しいタブで開きます。リンクのみで、何も変更しません。",
      createResponsesSheet:
        "Drive の forms/ フォルダに回答スプレッドシートを作成（または再利用）し、その ID を保存します。回答先の連携はご自身で行ってください（「回答」→「スプレッドシートにリンク」）。",
      reusedResponsesSheet:
        "この再利用フォームに既に接続されている回答シートを採用します（作成・変更はしません）。接続されていない場合は、Google フォームでご自身が接続するための単独シートの作成を提案します。",
      publishForm:
        "Google フォームを公開し、回答を受け付ける状態にします（Forms API を使用）。これによりユーザーがリンクを利用できます。フォームがリンクされていれば実行できます。フォームが非公開で作成された場合や、後で非公開・受付停止になった場合に使用します。",
      openResponsesSheet: "回答スプレッドシートを新しいタブで開きます。リンクのみです。",
      detach:
        "保存されたフォームリンク（formId/URL）をバックアップ枠に移して消去するだけです。フォームの削除、回答シートの解除、保存済みのシート ID の消去は行いません。",
      restoreBackup:
        "現在のフォームリンクとバックアップを入れ替えます。Detach や Replace を取り消します。現在の値とバックアップの値が入れ替わります。",
    },
    need: {
      schema: "先にスキーマへ質問項目を 1 つ以上追加してください。",
      notLinked: "すでにフォームがリンクされているため利用できません。",
      notLocked: "このフォームは ID で再利用中のため編集できません。",
      linkedForm: "先にフォームをリンクしてください。",
      responsesSheet: "先に回答シートを作成してください。",
      backup: "まだバックアップがありません。",
    },
    titleFirstRequired: "最初の行は「フォームタイトル」である必要があります。",
    noQuestions: "少なくとも 1 つの質問項目を追加してください。",
    alreadyLinked: "すでにフォームが連携されています。URL を変更する場合は「差し替え」、項目を更新する場合は「同期」を使用してください。",
    importPrompt: "既存の事前入力済み Google フォーム URL を貼り付けてください（末尾が &entry.<番号>= で終わる必要があります）:",
    replacePrompt: "リンク URL を差し替えます。現在: {{current}}\n新しい事前入力 URL を貼り付けてください:",
    confirmReplace: "リンク URL を差し替えますか？以前の値はバックアップとして保存され、復元できます。",
    urlImported: "URL をインポートしました。",
    urlReplaced: "URL を差し替えました。以前の値をバックアップ保存しました。",
    importError: "URL インポートエラー: {{msg}}",
    confirmRestore: "リンク URL とバックアップを入れ替えますか？",
    restored: "以前の URL を復元しました。",
    restoreError: "復元エラー: {{msg}}",
    schemaHeader: "フォーム項目（スキーマ）",
    schemaInfoNote: "スキーマの保存はシートのみを更新します。新規導入時に Google フォームへ反映するには、上の「新規作成」を使用してください。運用開始後は entry ID の変動を避けるため、Google フォームを直接編集してください。",
    saveSchema: "スキーマを保存",
    schemaSaved: "スキーマをシートに保存しました。",
    schemaSaveError: "スキーマ保存エラー: {{msg}}",
    confirmSaveSchema: "スキーマをシートに保存しますか？連携済みの Google フォームは変更されません。",
    colLabel: "ラベル",
    colType: "種別",
    colValues: "選択肢",
    colDescription: "説明",
    colActions: "操作",
    valuesPlaceholder: "選択肢1|選択肢2|選択肢3",
    descriptionPlaceholder: "補足説明（任意）",
    titlePlaceholder: "フォームのタイトル",
    formDescriptionPlaceholder: "フォームの説明文",
    sectionTitlePlaceholder: "セクションタイトル",
    sectionDescriptionPlaceholder: "セクションの説明（任意）",
    type: {
      text: "短文",
      textarea: "長文",
      select: "ドロップダウン",
      radio: "ラジオ",
      checkbox: "チェックボックス",
      title: "タイトル / セクション",
    },
    addField: "項目を追加",
    moveUp: "上へ移動",
    moveDown: "下へ移動",
    dragToReorder: "ドラッグして並べ替え",
    remove: "削除",
    edit: "スキーマを編集",
    cancel: "編集をキャンセル",
    locked: "誤操作を防ぐためロックされています。",
    idFieldMissing: "ディスペンサー ID を事前入力するため、ラベル「{{label}}」の行を追加してください。",
    choiceValuesMissing: "項目「{{label}}」には選択肢が必要です（| で区切ってください）。",
    noFields: "少なくとも 1 項目を追加してください。",
    confirmEdit: "スキーマのロックを解除して編集しますか？",
    openGoogleForm: "Google フォームを開く",
    templateHeader: "フォームテンプレート",
    templateHelp: "新規フォームは MewMaps/forms/Template を複製して作成されるため、本物のヘッダー画像・テーマ等の設定がそのまま引き継がれます。空のテンプレートをこのボタンで作成して Google フォームで装飾するか、「共有フォームを使う…」で既存フォーム（他アカウントから共有されたものを含む）を選び、その背景・テーマを取り込めます。Drive 上で直接作成したフォームは、ここで作成または選択するまでアプリからは見えません。",
    editTemplate: "テンプレートを編集",
    templateCreated: "MewMaps/forms/Template にテンプレートを作成しました。Google フォームでヘッダー画像を設定してから、「スキーマから作成」を実行してください。",
    templateOpened: "既存のテンプレートを開きました。Google フォームで編集後、「スキーマから作成」または「同期」を実行してください。",
    templateError: "テンプレートのセットアップに失敗しました：{{msg}}",
    importThemedTemplate: "共有フォームを使う…",
    pickTemplateTitle: "テンプレートとして使うフォームを選択",
    confirmThemedTemplate: "「{{name}}」を MewMaps/forms/Template に複製し、新規フォームのテンプレートとして使用しますか？現在のテンプレートは置き換えられます。",
    themedTemplateSet: "「{{name}}」をフォームテンプレートとして複製しました。新規フォームには背景・テーマ・ヘッダーが引き継がれます（設問はスキーマから再構築されます）。",
    themedTemplateError: "選択したフォームをテンプレートとして使用できませんでした：{{msg}}",
  },
  email: {
    title: "メール設定",
    dest: "宛先",
    cc: "Cc",
    bcc: "Bcc",
    senderName: "送信者名",
    subject: "件名",
    topMessage: "本文（冒頭）",
    bottomMessage: "本文（末尾）",
    save: "メール設定を保存",
    saved: "メール設定を保存しました",
    saveError: "メール設定の保存エラー: {{msg}}",
    locked: "誤操作を防ぐため、この設定はロックされています。",
    edit: "設定を編集",
    cancel: "編集をキャンセル",
    confirmSave: "メール設定を保存しますか？すべての送信レポートに影響します。",
    confirmEdit: "メール設定を編集できるようにロックを解除しますか？",
  },
  members: {
    title: "メンバー",
    intro: "このプロジェクトを共有しているが Drive フォルダを所有していないメンバーを登録し、各自の表示範囲を設定します。管理者はアプリ全体を、現地担当は現地入力とマップのみを利用できます。これはチーム運用上の利便機能であり、セキュリティ制御ではありません（ここに登録された全員が Google スプレッドシートで直接データを編集できます）。",
    introOwner: "メンバーをメールアドレスで追加し、アクセス権を選択します。追加するとプロジェクトのファイルが編集者として共有され、招待メールが送信されます。削除するとそのアクセス権は取り消されます。管理者はアプリ全体を、現地担当は現地入力とマップのみを利用できます。承諾後、メンバーはアプリで一度だけ「共有プロジェクトに参加」を行う必要があります。また管理者は、対応するビューを初めて開く際に共有フォルダの選択を求められる場合があります。",
    notOwnerNote: "プロジェクトの所有者ではありません。保存するとデータシートが共有され招待メールが送信されますが、写真・マップ・フォームについては、Google Drive で MewMaps フォルダを新しいメンバーに（編集者として）別途共有する必要があります。",
    inviteMessage: "MewMaps プロジェクトに追加されました。MewMaps を開き、この Google アカウントでサインインして「共有プロジェクトに参加」を選択してください。",
    savedSharePartial: "保存しました。次のアドレスには共有できませんでした: {{emails}} — アドレスを確認して再試行してください。",
    savedShareRootNote: "保存し、データシートを共有しました。一部のプロジェクトフォルダは自動共有できませんでした（MewMaps が作成していないファイル（例: フォームの回答シート）が含まれているためです）。Google Drive で MewMaps フォルダを次のユーザーに（編集者として）別途共有してください: {{emails}} — これで写真・マップ・フォームも利用できます。",
    openDriveFolder: "Google Drive で MewMaps フォルダを開く",
    email: "メールアドレス",
    emailPlaceholder: "name@example.com",
    role: "役割",
    roleManager: "管理者（フルアクセス）",
    roleFieldworker: "現地担当（現地入力＋マップ）",
    empty: "メンバーが未登録です。管理者として追加するまで、共有ユーザーは既定で現地担当になります。",
    addRow: "メンバーを追加",
    removeRow: "メンバーを削除",
    signedInAs: "{{email}} でサインイン中。フォルダ所有者は常にフルアクセスです。",
    save: "メンバーを保存",
    saved: "メンバーを保存しました",
    saveError: "メンバーの保存エラー: {{msg}}",
    locked: "誤操作を防ぐため、このリストはロックされています。",
    edit: "メンバーを編集",
    cancel: "編集をキャンセル",
    confirmSave: "メンバーリストを保存しますか？次回読み込み時に各メンバーの表示範囲が変わります。",
    confirmEdit: "メンバーリストを編集できるようにロックを解除しますか？",
  },
  table: {
    filterCampus: "キャンパス絞込み",
    filterBuilding: "建物絞込み",
    filterOwner: "担当者絞込み",
    actions: "操作",
    reportUrl: "報告URL",
    photos: "写真",
    folder: "フォルダ",
    openFolder: "Drive フォルダを開く",
    pictures: "写真",
    viewPictures: "写真を表示",
    openInMaps: "マップで開く",
    delete: "削除",
    derivedDisplayName: "部局・施設名と階から自動計算",
    selectRow: "この行を選択",
    selectRowNoId: "選択するには ID が必要です",
    selectAll: "すべて選択（絞込み対象）",
  },
  qr: {
    title: "QR コード ({{count}})",
    print: "印刷",
    close: "閉じる",
  },
  pictures: {
    title: "写真 ({{count}})",
    close: "閉じる",
    empty: "写真が見つかりません。",
    size: "サムネイルサイズ",
  },
  headers: {
    "#": "#",
    "ID": "ID",
    "担当者": "担当者",
    "キャンパス": "キャンパス",
    "部局、施設名": "部局、施設名",
    "建物": "建物",
    "階": "階",
    "設置場所": "設置場所",
    "備考": "備考",
    "アクセス": "アクセス",
    "表記名①": "表記名①",
    "緯度": "緯度",
    "経度": "経度",
    "写真フォルダID": "写真フォルダID",
    "写真ファイルID": "写真ファイルID",
  },
  tasks: {
    title: "タスク",
    intro: "情報が不足しているレコードを、対応に必要な作業ごとに分類しています。項目を開くと現地入力フォームで修正できます。",
    refresh: "更新",
    allClear: "対応が必要な項目はありません。すべてのレコードに ID・場所・座標・設置場所が揃っています。",
    count: "{{n}} 件",
    address: "対応する",
    group: {
      missingId: {
        title: "ID が未設定",
        desc: "ID が登録されていないレコードです（建物が「未設置」のプレースホルダー行が多くあります）。現地でディスペンサーの QR を読み取り、資料と照合して正しい ID を割り当ててください。同じ行に保存されます。",
      },
      missingLocation: {
        title: "場所情報が不足",
        desc: "キャンパス・部局／施設名・建物・階のいずれかが未入力です（空欄または「未設置」）。多くは施設の資料から補完できますが、建物・階の確認に現地調査が必要な場合があります。",
      },
      missingCoords: {
        title: "座標が未設定",
        desc: "地図上の位置が未設定です。現地で「位置情報を取得」して GPS を記録するか、地図上にピンを置いてください。",
      },
      missingInstallSpot: {
        title: "設置場所が未入力",
        desc: "設置場所が空欄です。多くは ID と手元の資料から推定でき、現地で確認できます。",
      },
    },
  },
  field: {
    title: "現地入力",
    id: "ID",
    assignee: "担当者",
    campus: "キャンパス",
    department: "部局、施設名",
    building: "建物",
    floor: "階",
    installLocation: "設置場所",
    access: "アクセス",
    displayName: "表記名①",
    notes: "備考",
    location: "位置情報を取得",
    locating: "位置情報を取得中…",
    locationSampling: "精度を改善中… ±{{m}} m",
    locationGot: "位置情報取得: {{lat}}, {{lng}} (±{{m}} m)",
    locationFailed: "位置情報の取得に失敗しました。手動入力してください。",
    locationDenied: "Windowsが位置情報をブロックしています。設定→プライバシーとセキュリティ→位置情報 を開き、「位置情報サービス」「アプリに位置情報へのアクセスを許可する」、および（最下部の）「デスクトップアプリに位置情報へのアクセスを許可する」をすべてオンにしてください。その後「位置情報を取得」を再度タップ、または下の地図でピンを直接設定してください。",
    accuracy: "精度: ±{{m}} m",
    geoUnavailable: "このブラウザでは位置情報を利用できません",
    latitude: "緯度",
    longitude: "経度",
    mapHint: "ピンをドラッグするか地図をタップして正確な位置を設定",
    openInMaps: "Google マップで開く",
    mapStandard: "標準地図",
    mapSatellite: "衛星写真",
    photos: "写真",
    takePhoto: "写真を撮影",
    choosePhotos: "写真を選択",
    enterId: "ID を入力してください",
    saved: "{{id}} を追加しました",
    updated: "{{id}} を更新しました",
    loadExisting: "既存を読込",
    loadedExisting: "{{id}} の既存値を読み込みました",
    clear: "クリア",
    cleared: "フォームをクリアしました",
    idExists: "この ID は既に存在します。送信すると上書きされます。",
    confirmOverwrite: "{{id}} は既に存在します。これらの値で上書きしますか？",
    addWatermark: "写真に透かしを追加",
    replaceWatermark: "透かし画像を差し替え",
    resetWatermark: "既定に戻す",
    confirmResetWatermark: "現在の透かしを既定の画像に置き換えますか？",
    watermarkUploaded: "透かし画像をアップロードしました",
    watermarkReset: "透かしを既定に戻しました",
    watermarkUploadFailed: "透かしのアップロードに失敗しました：{{msg}}",
  },
  kml: {
    title: "KMZ エクスポート",
    mapSettings: "地図設定",
    mapName: "地図名",
    filename: "ファイル名 (.kmz 自動付与)",
    commonPicture: "共通画像（全ピンに表示）",
    notSet: "未設定",
    chooseImage: "画像を選択してアップロード",
    saveSettings: "設定を保存",
    settingsSaved: "設定を保存しました",
    uploadingShared: "共通画像をアップロード中…",
    uploadedShared: "共通画像をアップロードしました",
    uploadFailed: "アップロード失敗: {{msg}}",
    filterCampus: "キャンパス絞込み",
    filterBuilding: "建物絞込み",
    countSummary: "対象: {{filtered}} / GPS 登録済み {{withGps}} 件 / 全 {{total}} 行",
    generate: "KMZ を生成・保存",
    generating: "処理中…",
    noGps: "GPS 情報を持つ行がありません",
    generated: "{{count}} 件の KMZ を保存・ダウンロードしました",
    openSaved: "保存済みファイルを開く",
    hint:
      "mymaps.google.com → 新しい地図を作成 → インポート で KMZ ファイルを読み込めます。各ピンにはディスペンサーの写真と共通画像が直接表示されます（エクスポート時に Drive 上の画像は公開設定になります）。",
  },
  importView: {
    title: "一括取込（XLSX + KML + JSON）",
    intro:
      "XLSX のみを選ぶと、行の追加（または上書き）だけを行います。3 つのファイル（XLSX：ID 付きディスペンサー情報、KML：GPS・写真、ラベル付き地点 JSON：座標 → ID）をすべて選ぶと、KML プレースマークを JSON と座標で完全一致照合して ID を取得し、その ID で XLSX 行に GPS を書き込み、写真を Drive にアップロードします。同じ URL の写真は重複アップロードしません。",
    xlsxFile: "XLSX ファイル",
    kmlFile: "KML ファイル",
    jsonFile: "ラベル付き地点 JSON",
    xlsxRowCount: "{{count}} 行",
    placemarkCount: "{{count}} プレースマーク",
    labeledCount: "{{count}} 件のラベル付き地点",
    preview: "プレビュー",
    matched: "一致（KML ↔ JSON ↔ XLSX）: {{count}} 件",
    unmatchedKml: "JSON 座標と一致しない KML: {{count}} 件",
    unmatchedJson: "KML に存在しない JSON ラベル: {{count}} 件",
    willCreate: "{{count}} 件の KML ID は XLSX に存在しません — 新規行を作成します。",
    pinsToProcess: "{{count}} 件の KML を処理（シートに既存の ID は再利用、未登録の ID は新規行を作成）。",
    uniqueUrls: "ユニーク写真 URL: {{total}} 件（Drive ファイル ID {{drive}}、その他 {{other}}）",
    commonUrls: "{{count}} 件の URL は複数のピンに共通（共通画像と判定 — 取込から除外）。",
    placemarksWithoutGps: "{{count}} 件のプレースマークに GPS がありません。",
    showUnmatchedKml: "未一致 KML を表示",
    showWillCreate: "作成予定 ID を表示",
    skipXlsx: "XLSX 追加をスキップ（KML と JSON のみ）",
    overwriteCheckbox: "シートを上書き（書式と追加列を保持）",
    overwriteHint: "必要な列がすべて見つかったため利用できます。",
    overwriteDisabledHint: "必要な列をすべて揃えると上書きが有効になります。",
    extrasDetected: "追加列を検出：{{names}}",
    confirmOverwrite: "既存の『mew_dispensers』シートを削除し、アップロードしたExcelファイルで置き換えます。続行しますか？",
    overwriteColumnOrderError: "上書きには A〜N 列が標準順で並んでいる必要があります。追加モードをご利用ください。",
    confirm: "取込を実行",
    running: "取込中…",
    done: "取込が完了しました。",
    confirmPhrase: "IMPORT",
    confirmPrompt: "この一括取込はシートを変更します。続行するには {{phrase}} と入力してください。",
    confirmMismatch: "入力が一致しないため取込を中止しました。",
    confirmAppend: "Excel ファイルの行をシートに追加しますか？",
    excelOnlyHint: "Excel のみ：行を追加（オプションが有効な場合は上書き）します。KML と JSON がなければ GPS・写真は処理されません。",
  },
  footer: {
    about: "このアプリについて",
    privacy: "プライバシーポリシー",
    terms: "利用規約",
  },
  wizard: {
    stepOf: "{{current}} / {{total}} ステップ",
    stepWelcome: "ようこそ",
    stepEmail: "通知設定",
    stepCampus: "設置場所",
    stepForm: "連絡フォーム",
    welcomeTitle: "MeW Maps のセットアップ",
    welcomeBody: "3 つのステップを完了すると、スプレッドシートと Google フォームを自動で作成します。",
    welcomeBodyEmail: "4 つのステップを完了すると、スプレッドシート・Google フォーム・メール通知を自動で作成します。",
    welcomeCreates: "自動で作成されるもの:",
    welcomeSheet: "ディスペンサー記録用 Google スプレッドシート",
    welcomeFolders: "写真・フォーム・アセット用 Drive フォルダ",
    welcomeForm: "各 QR コードにリンクされた Google フォーム",
    welcomeBackend: "フォーム送信用の回答スプレッドシート（フォームとの連携はご自身で）",
    emailTitle: "メール・通知設定",
    emailIntro: "QR コードからフォームが送信されると、このアドレスにメールが届きます。補充担当者に確実に届くよう設定してください。",
    campusTitle: "設置場所の選択肢",
    campusIntro: "ディスペンサー記録入力時のキャンパスドロップダウンに表示されます。組織の拠点に合わせて編集してください。",
    campusLabel: "表示ラベル",
    campusValue: "保存値",
    campusAddRow: "場所を追加",
    campusRemove: "削除",
    formTitle: "連絡フォーム",
    formIntro: "QR コードをスキャンしたユーザーが見るフォームです。組織に合わせて設定してください。後からフォーム画面で変更できます。",
    formIdLocked: "必須 — QR コードから自動入力されます",
    formAddField: "項目を追加",
    formAddOption: "選択肢を追加",
    formRemoveOption: "選択肢を削除",
    formDragToReorder: "ドラッグして並べ替え",
    back: "戻る",
    next: "次へ",
    finish: "セットアップを開始",
    creatingProject: "Google Drive プロジェクトを作成中…",
    savingSettings: "設定を保存中…",
    creatingForm: "フォームと回答シートを作成中…",
    linkingForm: "既存フォームを連携中…",
    setupError: "セットアップエラー: {{msg}}",
    formModeCreate: "フォームを新規作成",
    formModeCreateHelp: "下でレポートフォームを作成します。MewMaps がテンプレートから複製して作成・管理します。",
    formModeReuse: "既存フォームを再利用",
    formModeReuseHelp: "移行ですか？すでに使用中のフォームを指定できます（その QR コードは引き続き使えます）。編集は行いません。",
    reuseTitle: "既存フォームを再利用",
    reuseIntro: "すでに使用している Google フォーム（他アカウントから共有されたものを含む）を選択します。MewMaps は ID で連携して QR リンクを作成し、フォームは編集しません。",
    reuseSelectButton: "フォームを選択…",
    reuseChangeButton: "別のフォームを選択…",
    reuseReadOnlyNote: "このフォームは読み取り専用で連携されます。MewMaps は事前入力 QR URL の作成のために読み取るだけで、編集・公開・再構築は行いません。稼働中のフォームと既存の QR コードはそのままです。既存の回答シートはそのまま再利用され、新しいシートは作成されません。そのシートで（更新版の）メールバックエンドのセットアップを実行してください。",
    reusePickTitle: "再利用するフォームを選択",
    reuseNeedSelect: "再利用するフォームを選択するか、「フォームを新規作成」に切り替えてください。",
    noSheetAttached: "再利用するフォームにはまだ回答シートが接続されていません。メール通知には回答シートが必要です。ここで作成（任意）して Google フォームで接続するか（「回答」→「スプレッドシートにリンク」）、後で行うこともできます。",
    createSheetOptional: "回答シートを作成",
    creatingSheet: "作成中…",
    templateSectionTitle: "テーマと背景（任意）",
    templateHelp: "新規フォームに取り込みたい背景・テーマを持つ既存フォームを選択します。設問は下のスキーマから作成され、見た目だけが引き継がれます。空のままにすると装飾なしのフォームになります（テーマは後で Google フォームで設定できます）。",
    templateUseButton: "テンプレートを選択…",
    templateChangeButton: "別のテンプレートを選択…",
    templateClear: "テンプレートを解除",
    templatePickTitle: "テンプレートとして使うフォームを選択",
    applyingTemplate: "テンプレートを適用中…",
    doneTitle: "プロジェクトの準備ができました 🎉",
    doneIntro: "スプレッドシート、Google フォーム、回答シートのセットアップが完了しました。フォーム送信時にメール通知を送るには、以下のバックエンド設定（初回のみ）を行ってください。後で「フォーム」画面から設定することもできます。",
    doneFinish: "完了",
  },
  emailBackend: {
    title: "メール通知を有効にする（任意）",
    intro: "通知メールは、回答シート内の小さな Apps Script から送信されます。以下の手順で一度だけ設定してください。MewMaps 自体がメールを送ることはありません。",
    step1: "回答シートで「拡張機能 ▸ Apps Script」を開きます。",
    openResponsesSheet: "回答シートを開く",
    step2: "MewMail ライブラリを追加します：「ライブラリ ▸ + 」で下のスクリプト ID を貼り付け、識別子を {{identifier}} に設定して「追加」します。",
    shareNote: "MewMail ライブラリはマーケットプレイスにはありません。追加する前に、プロジェクト開発者に閲覧権限の共有を依頼してください。",
    step3: "次のコードを Code.gs に貼り付けます（既存の内容は置き換えてください）：",
    step4: "setup 関数を選択して一度だけ実行し、求められる権限を承認します。これによりフォームが回答シートにもリンクされます。",
    scriptIdLabel: "ライブラリのスクリプト ID",
    codeLabel: "Code.gs",
    copy: "コピー",
    copied: "コピーしました",
  },
} as const;

export default ja;
